import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  "& .simulations-filter": {
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
      borderBottom: "#211F45 1px solid",

      margin: "0 -1rem",
      padding: "20px 15px",
    },
    "& > div": {
      position: "relative",
      [theme.breakpoints.down("md")]: {
        width: "50%",
        textAlign: "center",
        justifyContent: "center",
      },
      "& .filter-dropdown": {
        background: "#030039",
        position: "absolute",
        minWidth: "328px",
        textAlign: "left",
        right: 0,
        border: "#211F45 1px solid ",
        boxShadow:
          "0px 12px 16px -4px rgba(0, 91, 140, 0.10), 0px 4px 6px -2px rgba(0, 91, 140, 0.03), 0px 2px 2px -1px rgba(0, 91, 140, 0.04)",
        borderRadius: "12px",
        marginTop: "10px",
        zIndex: 99,
        [theme.breakpoints.down("md")]: {
          minWidth: "unset",
          right: "auto",
          zIndexL: 999,
        },
        "& .filter-heading, & .filter-item": {
          padding: "0 20px",
        },
        "& .filter-heading": {
          margin: "20px 0 0 0",
          display: "flex",
          justifyContent: "space-between",
          "& strong": {
            fontSize: "14px",
          },
          "& button": {
            border: 0,
            background: "transparent",
            padding: 0,
            color: "#01ECFF",
            fontFamily: "inherit",
            fontWeight: 500,
            cursor: "pointer",
          },
        },
        "& .filter-item": {
          padding: "20px",
          borderBottom: "#211F45 1px solid",
          "&:last-child": {
            borderBottom: 0,
          },
          "& strong": {
            display: "block",
            marginBottom: "10px",
            textTransform: "uppercase",
            fontSize: "12px",
            color: "#A87EFF",
            fontWeight: 600,
          },
          "& .date-ranges": {
            fontSize: "12px",
          },
          "& .apply-filters-btn": {
            width: "100%",
          },
          "& .rdp-root": {
            "& .rdp-caption_label": {
              fontSize: "14px",
            },
            "& .rdp-chevron": {
              fill: "#fff",
              opacity: ".6",
              width: "18px",
            },
            "& .rdp-weekday": {
              color: "#D1C7FF",
              opacity: "1",
            },
            "& .rdp-day_button": {
              fontSize: "14px",
            },
            "& .rdp-today": {
              color: "#01ECFF",
            },
            "& .rdp-range_start,  & .rdp-range_middle,  & .rdp-range_end": {
              background: "transparent",
            },
            "& .rdp-day": {
              border: 0,
              "&.rdp-selected, &.rdp-range_start, &.rdp-range_end": {
                "& button": {
                  background: "rgb(0, 178, 214)",
                  borderColor: "rgb(0, 178, 214)",
                  borderRadius: "100%",
                },
              },
              "&.rdp-range_middle": {
                "& button": {
                  background: "#A87EFF",
                  borderColor: "#A87EFF",
                  borderRadius: "100%",
                  color: "#fff",
                },
              },
            },
          },
        },
      },
    },
    "& .filter-btn": {
      display: "flex",
      border: 0,
      padding: "10px 14px",
      background: "#211F45",
      borderRadius: "8px",
      alignItems: "center",
      fontWeight: "600",
      fontSize: "14px",
      color: "#FEFEFE",
      gap: "5px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      fontFamily: "inherit",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        textAlign: "center",
        justifyContent: "center",
      },
      "&:disabled": {
        opacity: ".5",
        cursor: "not-allowed",
      },
      "&:hover, &.active": {
        background: "#00B2D6",
      },
      "& svg": {
        width: 20,
        height: 20,
      },
      "&.sort": {
        "& svg": {
          width: 15,
          height: 15,
        },
      },
    },
    "& .mobile-sort-filters": {
      "& .filter-dropdown": {
        padding: "20px",
        "& .fields-container": {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          "& label": {
            fontSize: "14px",
          },
        },
      },
    },
  },

  "& .sims-loading": {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    padding: "50px 0",
    "& span": {
      opacity: ".8",
    },
  },
  "& #mobile-past-sims": {
    "& .heading-top": {
      marginBottom: "20px",
      display: "flex",
      justifyContent: "space-between",
      borderTop: "#211F45 1px solid",

      margin: "0 -1rem",
      padding: "20px 15px 0 20px",
      "& h2": {
        margin: 0,
        fontWeight: "500",
      },
    },
  },
}));
